/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastname1Inputs */

const en__field_lastname1 = /** @type {(inputs: _Field_Lastname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Name`)
};

const de__field_lastname1 = /** @type {(inputs: _Field_Lastname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "Last Name" |
*
* @param {_Field_Lastname1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_lastname1 = /** @type {((inputs?: _Field_Lastname1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastname1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_lastname1(inputs)
	return de__field_lastname1(inputs)
});
export { _field_lastname1 as "_field_lastName" }